import React, { Component } from "react"
import logo from "../assets/logo.svg"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"
import Fab from "@mui/material/Fab"
import Fade from "@mui/material/Fade"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Add from "@mui/icons-material/Add"
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined"
import UploadExperienceDialog from "./dialogs/UploadExperienceDialog"

export default withTranslation()(
  withRouter(
    class AdminSidebar extends Component {
      state = {
        uploadExperienceOpen: false,
      }

      computeTextWidth(text) {
        let canvas =
          this.computeTextWidth.canvas ||
          (this.computeTextWidth.canvas = document.createElement("canvas"))
        let context = canvas.getContext("2d")
        let metrics = context.measureText(text)

        return metrics.width * 2 + 16
      }

      render() {
        const { t, experiences, history, loading, setExperiences } = this.props
        const { uploadExperienceOpen } = this.state

        if (document.getElementsByClassName("MuiTabs-scroller")[0]) {
          document.getElementsByClassName(
            "MuiTabs-scroller"
          )[0].style.overflow = "auto"
        }

        return (
          <>
            <div
              style={{
                width: "33%",
                maxWidth: "384px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Fab
                color="primary"
                style={{
                  position: "absolute",
                  left: "min(304px, calc(33% - 80px))",
                  bottom: "96px",
                  backgroundColor: "white",
                  color: "#181818",
                  borderRadius: "16px",
                  zIndex: 1100,
                }}
                component="a"
                href="./Guida Lapwing App.pdf"
                target="_blank"
                download
              >
                <DescriptionOutlined />
              </Fab>
              <Fab
                color="primary"
                onClick={() => this.setState({ uploadExperienceOpen: true })}
                style={{
                  position: "absolute",
                  left: "min(304px, calc(33% - 80px))",
                  bottom: "24px",
                  backgroundColor: "#181818",
                  color: "white",
                  borderRadius: "16px",
                  zIndex: 1100,
                }}
              >
                <Add />
              </Fab>
              <div style={{ height: "256px", display: "flex" }}>
                <img
                  alt=""
                  src={logo}
                  style={{ maxWidth: "152px", margin: "auto" }}
                  className="notSelectable"
                />
              </div>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "calc(100% - 336px)",
                  }}
                >
                  <Fade
                    in={loading}
                    style={{
                      transitionDelay: loading ? "800ms" : "0ms",
                    }}
                    unmountOnExit
                  >
                    <CircularProgress />
                  </Fade>
                </div>
              ) : experiences.length ? (
                <Tabs
                  orientation="vertical"
                  variant="fullWidth"
                  scrollButtons={false}
                  value={
                    queryStringify.parse(window.location.search).experience
                  }
                  onChange={(_, _id) =>
                    history.push("/admin?experience=" + _id)
                  }
                  style={{
                    width: "100%",
                    height: "calc(100% - 256px)",
                  }}
                  TabIndicatorProps={{
                    style: {
                      display: experiences[0] ? "initial" : "none",
                      width: `min(${this.computeTextWidth(
                        experiences.find(
                          ({ _id }) =>
                            _id ===
                            queryStringify.parse(window.location.search)
                              .experience
                        )?.name
                      )}px, calc(100% - 32px))`,
                      height: "16px",
                      margin: "23px auto 0 auto",
                      left: 0,
                      backgroundColor: "#C3BF8D",
                    },
                  }}
                >
                  {experiences
                    .sort((a, b) =>
                      a.name.toLowerCase() > b.name.toLowerCase()
                        ? 1
                        : a.name.toLowerCase() < b.name.toLowerCase()
                        ? -1
                        : 0
                    )
                    .map(({ _id, name }) => (
                      <Tab
                        disableRipple
                        value={_id}
                        key={_id}
                        label={name}
                        style={{
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: 600,
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          color: "#181818",
                          zIndex: 1000,
                        }}
                      />
                    ))}
                </Tabs>
              ) : (
                <Typography
                  variant="h5"
                  style={{
                    lineHeight: "64px",
                    fontWeight: 600,
                    height: "calc(100% - 336px)",
                  }}
                >
                  {t`No experiences`}
                </Typography>
              )}
            </div>
            <UploadExperienceDialog
              open={uploadExperienceOpen}
              close={() => this.setState({ uploadExperienceOpen: false })}
              setExperiences={setExperiences}
              experiences={experiences}
            />
          </>
        )
      }
    }
  )
)
